import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-countdown-component',
  templateUrl: './countdown-component.component.html',
  styleUrls: ['./countdown-component.component.css']
})
export class CountdownComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
